import React from "react";

import { Button, TextField, Typography } from "@material-ui/core";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import { withStyles } from "@material-ui/core/styles";

import SimpleDialog from "components/SimpleDialog";

import { addOwner, clearOwner, hideAddOwner, selectAddOwnerVisibility, selectOwner, setOwner, showAddOwner } from "modules/admin/accounts/users/usersSlice";
import { useAppDispatch, useAppSelector } from "store";

const StyledButton = withStyles(theme => ({
    root: {
        marginRight: theme.spacing(2)
    }
}))(Button);

const StyledTextField = withStyles(theme => ({
    root: {
        "& .MuiInputBase-root": {
            // @ts-ignore
            backgroundColor: theme.palette.quaternary.main
        }
    },
}))(TextField);

interface AddOwnerProps {
    accountId: string,
    usersCount: number
}

const AddOwner: React.FC<AddOwnerProps> = (props) => {
    const { accountId, usersCount } = props;
    const dispatch = useAppDispatch();
    const owner = useAppSelector(selectOwner);
    const addOwnerVisibility = useAppSelector(selectAddOwnerVisibility);
    const show = (addOwnerVisibility.isVisible) && (accountId === addOwnerVisibility.accountId);
    const disabled = usersCount > 0;

    const handleAddOwnerClick = () => {
        dispatch(showAddOwner(accountId));
    };

    const handleSubmitClick = () => {
        dispatch(addOwner(accountId));
    };

    const handleCloseClick = () => {
        dispatch(hideAddOwner());
        dispatch(clearOwner());
    };

    const handleFirstNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const firstName = event.target.value;
        const newOwner = { ...owner, firstName, errors: { ...owner.errors, firstName: "" } };
        dispatch(setOwner(newOwner));
    };

    const handleLastNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const lastName = event.target.value;
        const newOwner = { ...owner, lastName, errors: { ...owner.errors, lastName: "" } };
        dispatch(setOwner(newOwner));
    };

    const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const email = event.target.value;
        const newOwner = { ...owner, email, errors: { ...owner.errors, email: "" } };
        dispatch(setOwner(newOwner));
    };

    return (
        <>
            <StyledButton
                variant="contained"
                size="medium"
                color="secondary"
                startIcon={<AddRoundedIcon />}
                disableElevation
                onClick={handleAddOwnerClick}
                disabled={disabled}
            >
                Add owner
            </StyledButton>
            <SimpleDialog
                open={show}
                onClose={handleCloseClick}
                title={
                    <Typography variant="h5" component="div">Add owner</Typography>
                }
                content={
                    <>
                        <StyledTextField
                            label="First name"
                            variant="outlined"
                            size="small"
                            color="secondary"
                            margin="normal"
                            value={owner.firstName}
                            onChange={handleFirstNameChange}
                            error={!!owner.errors.firstName}
                            helperText={owner.errors.firstName}
                            required
                            fullWidth
                        />
                        <StyledTextField
                            label="Last name"
                            variant="outlined"
                            size="small"
                            color="secondary"
                            margin="normal"
                            value={owner.lastName}
                            onChange={handleLastNameChange}
                            error={!!owner.errors.lastName}
                            helperText={owner.errors.lastName}
                            required
                            fullWidth
                        />
                        <StyledTextField
                            label="Email"
                            variant="outlined"
                            size="small"
                            color="secondary"
                            margin="normal"
                            value={owner.email}
                            onChange={handleEmailChange}
                            error={!!owner.errors.email}
                            helperText={owner.errors.email}
                            required
                            fullWidth
                        />
                    </>
                }
                actions={
                    <Button variant="contained" color="secondary" disableElevation onClick={handleSubmitClick}>
                        Add owner
                    </Button>
                }
            />
        </>
    );
};

export default AddOwner;
